// extracted by mini-css-extract-plugin
module.exports = {"header":"e_Wo","gallery":"e_Xo","label":"e_Yo"};